import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:9000",
  }),
  endpoints: (builder) => ({
    getTeam: builder.query({
      query: () => "/team",
    }),
    getProjects: builder.query({
      query: () => "/projects",
    }),
  }),
});

export const { useGetTeamQuery, useGetProjectsQuery } = apiSlice;
